export const consumeColumn = [
  {
		label: '消耗',
		id: 'cost',
	},
	{
		label: '激活',
		id: 'activeCnt',
	},
]

export const basicColumn = [
	
	{
		label: 'roi_1',
		id: 'roi1',
	},
	{
		label: 'roi_2',
		id: 'roi2',
	},
	{
		label: 'roi_3',
		id: 'roi3',
	},
	{
		label: 'roi_7',
		id: 'roi7',
	},
	{
		label: 'roi_15',
		id: 'roi15',
	},
	{
		label: 'roi_30',
		id: 'roi30',
	},
];

export const sevenPredictColumn = [
	{
		label: 'R^2_7',
		id: 'day7R',
	},
	{
		label: 'roi_15',
		id: 'pred15Roi7d',
	},
	{
		label: 'roi_30',
		id: 'pred30Roi7d',
	},
	{
		label: 'roi_60',
		id: 'pred60Roi7d',
	},
	{
		label: 'roi_90',
		id: 'pred90Roi7d',
	},
];

export const thirtyPredictColumn = [
	{
		label: 'R^2_30',
		id: 'day30R',
	},
	{
		label: 'roi_60',
		id: 'pred60Roi30d',
	},
	{
		label: 'roi_90',
		id: 'pred90Roi30d',
	},
];

export const dimensionList = [
	{
		label: '全部(日期)',
		id: 1,
	},
	{
		label: '账户',
		id: 2,
	},
	{
		label: 'campaign',
		id: 3,
	},
];

export const dimensionReflect = new Map([
	[1, { label: '全部(日期)', props: 'stateTime' }],
	[2, { label: '账户', props: 'advertiserId' }],
  [3, { label: 'campaign', props: 'campaignId' }],
]);
